var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "BranchStockTransfer" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "MovementNumber",
                        error: _vm.$v.form.MovementNumber,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.MovementNumber
                        },
                        model: {
                          value: _vm.form.MovementNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "MovementNumber", $$v)
                          },
                          expression: "form.MovementNumber"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "RepresentativeId",
                        error: _vm.$v.form.RepresentativeId
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: _vm.insertReadonly.RepresentativeId,
                          url:
                            "VisionNextEmployee/api/Employee/AutoCompleteSearch",
                          label: "Description1",
                          searchable: true,
                          "custom-option": true,
                          "or-condition-fields":
                            "Code,Description1,CommercialTitle,Name,Surname",
                          "is-customer": true
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedSearchType(
                              "RepresentativeId",
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "MovementDate",
                        error: _vm.$v.form.MovementDate,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextDatePicker", {
                        attrs: { disabled: _vm.insertReadonly.MovementDate },
                        model: {
                          value: _vm.form.MovementDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "MovementDate", $$v)
                          },
                          expression: "form.MovementDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "MovementTime",
                        error: _vm.$v.form.MovementTime,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextTimePicker", {
                        attrs: { disabled: _vm.insertReadonly.MovementTime },
                        model: {
                          value: _vm.form.MovementTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "MovementTime", $$v)
                          },
                          expression: "form.MovementTime"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "GenExp1",
                        error: _vm.$v.form.GenExp1,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.GenExp1
                        },
                        model: {
                          value: _vm.form.GenExp1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "GenExp1", $$v)
                          },
                          expression: "form.GenExp1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          type: "number",
                          disabled: _vm.insertReadonly.StatusId,
                          toggle: ""
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.BranchStockTransfer.Items"),
                    active: ""
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "FromBranchId",
                            error: _vm.$v.form.FromBranchId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextBranch/api/Branch/Search",
                              "dynamic-and-condition": { StatusIds: [1] },
                              disabled: _vm.insertReadonly.FromBranchId,
                              searchable: ""
                            },
                            on: {
                              input: function($event) {
                                _vm.selectedSearchType("FromBranchId", $event)
                                _vm.initWarehouse("from", $event)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "FromWarehouseId",
                            error: _vm.$v.form.FromWarehouseId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled:
                                _vm.insertReadonly.FromWarehouseId ||
                                !_vm.form.FromBranchId,
                              source: _vm.fromWarehouses
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "FromWarehouseId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.fromWarehouse,
                              callback: function($$v) {
                                _vm.fromWarehouse = $$v
                              },
                              expression: "fromWarehouse"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "FromStatusId",
                            error: _vm.$v.form.FromStatusId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url:
                                "VisionNextStockManagement/api/StockStatus/Search?v=1",
                              disabled:
                                _vm.insertReadonly.FromStatusId ||
                                !_vm.form.FromWarehouseId,
                              filter: function(i) {
                                return i.Code !== "RZRV"
                              }
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "FromStatusId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.fromStatus,
                              callback: function($$v) {
                                _vm.fromStatus = $$v
                              },
                              expression: "fromStatus"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ToBranchId",
                            error: _vm.$v.form.ToBranchId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              source: _vm.toBranchs,
                              disabled:
                                _vm.insertReadonly.ToBranchId ||
                                !_vm.form.FromBranchId
                            },
                            on: {
                              input: function($event) {
                                _vm.selectedSearchType("ToBranchId", $event)
                                _vm.initWarehouse("to", $event)
                              }
                            },
                            model: {
                              value: _vm.toBranch,
                              callback: function($$v) {
                                _vm.toBranch = $$v
                              },
                              expression: "toBranch"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ToWarehouseId",
                            error: _vm.$v.form.ToWarehouseId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              source: _vm.toWarehouses,
                              disabled:
                                _vm.insertReadonly.ToWarehouseId ||
                                !_vm.form.ToBranchId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "ToWarehouseId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.toWarehouse,
                              callback: function($$v) {
                                _vm.toWarehouse = $$v
                              },
                              expression: "toWarehouse"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ToStatusId",
                            error: _vm.$v.form.ToStatusId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url:
                                "VisionNextStockManagement/api/StockStatus/Search?v=2",
                              disabled:
                                _vm.insertReadonly.ToStatusId ||
                                !_vm.form.ToWarehouseId,
                              filter: function(i) {
                                return i.Code !== "RZRV"
                              }
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "ToStatusId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.toStatus,
                              callback: function($$v) {
                                _vm.toStatus = $$v
                              },
                              expression: "toStatus"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.BranchStockTransfer.ItemCode"
                            ),
                            required: true,
                            error: _vm.$v.item,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              searchable: "",
                              url:
                                "VisionNextItem/api/Item/SearchWithMovementStock",
                              "dynamic-and-condition": {
                                StatusIds: [1],
                                CardTypeIds: [1, 2, 8],
                                FromWarehouseIds: [_vm.form.FromWarehouseId],
                                ToWarehouseIds: [_vm.form.ToWarehouseId],
                                FromWarehouseStatus: [_vm.form.FromStatusId],
                                ToWarehouseStatus: [_vm.form.ToStatusId],
                                MovementType: [1]
                              },
                              "or-condition-fields": "Code,Description1",
                              "custom-option": true,
                              disabled:
                                !_vm.form.FromWarehouseId ||
                                !_vm.form.ToWarehouseId ||
                                !_vm.form.FromStatusId ||
                                !_vm.form.ToStatusId
                            },
                            on: { input: _vm.selectedItem },
                            model: {
                              value: _vm.item,
                              callback: function($$v) {
                                _vm.item = $$v
                              },
                              expression: "item"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.BranchStockTransfer.Description1"
                            ),
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.branchStockTransferItem.Description1,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.branchStockTransferItem,
                                  "Description1",
                                  $$v
                                )
                              },
                              expression: "branchStockTransferItem.Description1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.BranchStockTransfer.FromWhStockQuantity"
                            ),
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { disabled: true, type: "text" },
                            model: {
                              value: _vm.branchStockTransferItem.FromQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.branchStockTransferItem,
                                  "FromQuantity",
                                  $$v
                                )
                              },
                              expression: "branchStockTransferItem.FromQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.BranchStockTransfer.ToWhStockQuantity"
                            ),
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { disabled: true, type: "text" },
                            model: {
                              value: _vm.branchStockTransferItem.ToQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.branchStockTransferItem,
                                  "ToQuantity",
                                  $$v
                                )
                              },
                              expression: "branchStockTransferItem.ToQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.BranchStockTransfer.PlanQuantity"
                            ),
                            required: true,
                            error: _vm.$v.branchStockTransferItem.Quantity,
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number", min: "1" },
                            on: {
                              keypress: function($event) {
                                return _vm.onlyForCurrencyDot($event)
                              }
                            },
                            model: {
                              value: _vm.branchStockTransferItem.Quantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.branchStockTransferItem,
                                  "Quantity",
                                  $$v
                                )
                              },
                              expression: "branchStockTransferItem.Quantity"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "ml-auto",
                          attrs: { cols: "10", md: "2" }
                        },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("AddDetailButton", {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.addItems($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "10", md: "2" } },
                        [
                          _c("NextMultipleSelection", {
                            attrs: {
                              name: "BranchTransferMultipleItem",
                              "filter-func": function(i) {
                                return (
                                  i.Quantity > 0 && i.Quantity < i.FromQuantity
                                )
                              },
                              "dynamic-and-condition": {
                                FromWarehouseIds: [_vm.form.FromWarehouseId],
                                ToWarehouseIds: [_vm.form.ToWarehouseId],
                                FromWarehouseStatus: [_vm.form.FromStatusId],
                                ToWarehouseStatus: [_vm.form.ToStatusId],
                                MovementType: [1]
                              },
                              "disabled-button":
                                !_vm.form.FromWarehouseId ||
                                !_vm.form.ToWarehouseId ||
                                !_vm.form.FromStatusId ||
                                !_vm.form.ToStatusId,
                              validations: _vm.multipleValidations
                            },
                            model: {
                              value: _vm.form.BranchStockTransferItems,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "BranchStockTransferItems",
                                  $$v
                                )
                              },
                              expression: "form.BranchStockTransferItems"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-table-simple",
                            {
                              attrs: { responsive: "", bordered: "", small: "" }
                            },
                            [
                              _c(
                                "b-thead",
                                [
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.BranchStockTransfer.ItemCode"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.BranchStockTransfer.Items"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.BranchStockTransfer.FromWhStockQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.BranchStockTransfer.ToWhStockQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.BranchStockTransfer.PlanQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("list.operations")))
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tbody",
                                _vm._l(
                                  _vm.form.BranchStockTransferItems,
                                  function(r, i) {
                                    return _c(
                                      "b-tr",
                                      { key: i },
                                      [
                                        _c("b-td", [_vm._v(_vm._s(r.Code))]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.Description1))
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.FromQuantity))
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.ToQuantity))
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.Quantity))
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "b-td",
                                          { staticClass: "text-center" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "far fa-trash-alt text-danger",
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeItems(r)
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f4c5566", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f4c5566","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BranchStockTransfer/insert.vue
// module id = null
// module chunks = 